import { LandholdingDetails, ProjectDetailsStepState, ProjectEntryMethod, ProjectRow } from "../../../../../models";

// Manual and upload rows now share one bucket - whichever entry method is active owns details.data.
export const getActiveProjectRows = (details: ProjectDetailsStepState): ProjectRow[] => details.data.rows;

// 0 is a real area, so only null/undefined/"" count as empty.
const isFilled = (value: string | number | null | undefined): boolean =>
  value !== null && value !== undefined && value !== "";

// Every editable field counts: switching entry method discards the row, so a row holding nothing but
// a postcode still has to raise the warning modal.
const isRowPopulated = (row: ProjectRow): boolean =>
  Object.entries(row).some(([field, value]) => field !== "key" && isFilled(value));

const isLandholdingPopulated = (landholding: LandholdingDetails): boolean => Object.values(landholding).some(isFilled);

export const getEnteredRowCount = (details: ProjectDetailsStepState, method: ProjectEntryMethod): number =>
  method === "upload" ? details.data.rows.length : details.data.rows.filter(isRowPopulated).length;

export const hasEnteredData = (details: ProjectDetailsStepState, method: ProjectEntryMethod): boolean => {
  if (getEnteredRowCount(details, method) > 0) return true;
  if (method !== "manual") return false;

  return details.isLandholding && isLandholdingPopulated(details.data.landholding);
};
